import styled from 'styled-components'

export const Td = styled.td`
  color: ${props => (props.color ? props.color : props.theme.colors.secondary)};
  font-size: ${props => props.theme.fontSizes.table.td};
  font-family: ${props => props.theme.fonts.robotoRegular};
  letter-spacing: 0.1px;
  opacity: 0.75;
  padding: 0 10px;

  &.no-opacity {
    opacity: 1;
  }

  .flex-centered {
    display: flex;
    justify-content: center;
  }

  &.centered {
    text-align: center;
  }

  &.no-wrap {
    white-space: nowrap;
  }

  &.link {
    color: ${props => props.theme.colors.primary};
    cursor: pointer;
  }
  &.align-right {
    text-align: right;
  }
  &.bold {
    font-weight: bold;
    color: black;
    opacity: 1;
  }

  > a {
    color: ${props =>
      props.color ? props.color : props.theme.colors.secondary};
    font-size: ${props => props.theme.fontSizes.table.td};
    font-family: ${props => props.theme.fonts.robotoRegular};
    letter-spacing: 0.1px;
    display: block;
    text-decoration: none;
  }
`



// WEBPACK FOOTER //
// ./src/Components/Table/Td/index.js